// @core/api/endpoints/billing/update_invoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateInvoiceRequest,
  UpdateInvoiceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Update invoice (draft only)
 * Updates a draft invoice's memo or due date. Only draft invoices can be modified; finalized invoices are immutable.
 */
export async function UpdateInvoice(
  id: string,
  data: UpdateInvoiceRequest,
  options?: RequestOptions
): Promise<UpdateInvoiceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoices/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdateInvoiceResponse>(requestPath, data, requestOptions);
}
